module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shareTitle":"Share the app","shareDescription":"The app can be shared with this link","shareButton":"Share","dangerZone":"danger zone","shareCopied":"Link copied!","reset":"Reset","version":"version"}}')
  delete Component.options._Ctor
}
